/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { of } from "rxjs";
import { MyInjector } from "@src/app/app.module";
import { TenantId } from "@src/app/model/abstract-object";
import { Person } from "@src/app/model/person";
import { RequestContextService } from "@src/app/modules/crm/request-context.service";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";

export class PersonRequestAction implements IFormAction {
    name = $localize`Create Request`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'add_circle';
    approvalNeeded = false;
    disabled = false;
    approvalText = "";
    tipText: string;
    teamId: TenantId;
    person: Person;

    /**
     * A case rather than a work order - a contact reports work, they do not carry it out.
     *
     * Deliberately ignores the argument: form-top-actions hands an action the form value, which
     * carries only the fields with sendServer set, and fullName is not one of them - nor is it on
     * the person form at all. The stepper's Contact pick-link renders from person.fullName, so the
     * form value produces a link with no text. setup() is given the real focusItem, so that is what
     * travels.
     */
    action() {
        const person = this.person;
        MyInjector.instance.get(RequestContextService)
            .newRequest({ requestType: 'case', teamId: this.teamId, person, unit: person.personUnits?.[0]?.unit })
            .subscribe();
        return of(this.person);
    }
    //  setup(serviceRequest: ServiceRequest) {
    setup(person: Person) {
        this.teamId = person?.teamId;
        this.person = person;
        this.show = !!this.teamId && MyInjector.instance.get(RequestContextService).canCreate();
    }
}
